import _ from 'lodash';

import { MSR_ACTION_TYPE } from 'store/companies/actions/msr.actions';
import { RESET_STATE } from 'store/global/actions';

const initialState = {};

const msrReducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case MSR_ACTION_TYPE.GET_MSR:
      return payload || initialState;

    case MSR_ACTION_TYPE.EDIT_MSR:
    case MSR_ACTION_TYPE.CREATE_MSR:
      return { ...state, [payload.id]: payload };

    case MSR_ACTION_TYPE.DELETE_MSR:
      return _.omit(state, payload);

    case RESET_STATE:
      return initialState;

    default:
      return state;
  }
};

export default msrReducer;
